import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';
import * as CrmServiceProxies from './crm-Service-proxies';
import * as AudioRecordingService from './AudioRecordingService';
import * as TicketServiceProxies from './ticketing-service-proxies';
import * as DocumentsServiceProxy from './documents-service-proxies';
import * as ReminderServiceProxy from './reminder-service-proxies';
import * as EmailServiceProxy from './email-service-proxies';
import * as TodoListServiceProxy from './todo-list-service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.MeetingServiceProxy,
        AudioRecordingService.AudioRecordingService,
        TicketServiceProxies.TicketServiceProxy,
        DocumentsServiceProxy.DocumentsServiceProxy,
        DocumentsServiceProxy.DocumentLocationServiceProxy,
        DocumentsServiceProxy.DocumentSendReasonServiceProxy,
        ReminderServiceProxy.ReminderServiceProxy,
        TodoListServiceProxy.TodoListServiceProxy,
        EmailServiceProxy.EmailServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.CountryServiceProxy,
        ApiServiceProxies.EducationalInstitutionServiceProxy,
        ApiServiceProxies.FileTypeServiceProxy,
        ApiServiceProxies.CaseServiceProxy,
        ApiServiceProxies.EducationalInstitutionTypeServiceProxy,
        ApiServiceProxies.CaseRequestsServiceProxy,
        ApiServiceProxies.FileUploadRequestServiceProxy,
        ApiServiceProxies.FileServiceProxy,
        ApiServiceProxies.EducationalInstitutionLayerServiceProxy,
        ApiServiceProxies.ExamTypeServiceProxy,
        ApiServiceProxies.ExamServiceProxy,
        ApiServiceProxies.GradeServiceProxy,
        ApiServiceProxies.MilitaryServiceServiceProxy,
        ApiServiceProxies.StatusServiceProxy,
        ApiServiceProxies.PayForServiceProxy,
        ApiServiceProxies.CurrencyTypeServiceProxy,
        ApiServiceProxies.SupplierServiceProxy,
        ApiServiceProxies.AccountingServiceProxy,
        ApiServiceProxies.CityServiceProxy,
        ApiServiceProxies.ScholarshipServiceProxy,
        ApiServiceProxies.ContractServiceProxy,
        ApiServiceProxies.ContractInsttallmentsServiceProxy,
        ApiServiceProxies.MeetingTypeServiceProxy,
        CrmServiceProxies.ApplicationServiceProxy,
        ApiServiceProxies.AdministrationServiceServiceProxy,
        CrmServiceProxies.ApplicationStatusLogServiceProxy,
        CrmServiceProxies.StatusValidMovementServiceProxy,
        ApiServiceProxies.TagServiceProxy,
        ApiServiceProxies.AwarenessSourceServiceProxy,
        ApiServiceProxies.ReferrerServiceProxy,
        ApiServiceProxies.CaseReportServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
